import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import Copyright from '../components/Copyright';
import theme from '../components/theme';
import {emailRegex} from '../helpers/TextFields';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Hidden } from '@mui/material';

function ForgotPassword() {

  const [email, setEmail] = React.useState('');
  const [errorTitle, setErrorTitle] = React.useState("Error");
  const [openErrorDialog, setOpenErrorDialog] = React.useState(false);
  const [openEmailSentDialog, setOpenEmailSentDialog] = React.useState(false);
  const [errorCode, seterrorCode] = React.useState('');
  const [circleProg, setCircleProg] = React.useState(false);

  const handleOpenEmailSentDialog = () => {
    setOpenEmailSentDialog(true);
  };

  const handleCloseEmailSentDialog = () => {
    setOpenEmailSentDialog(false);

  };

  const handleOpenErrorDialog = () => {
    setOpenErrorDialog(true);
  };

  const handleCloseErrorDialog = () => {
    setOpenErrorDialog(false);
  };

  const handleSubmit = (event) => {
    if(circleProg)
    {
      return;
    }
    setCircleProg(true);
    event.preventDefault();
    if(!emailRegex.test(email))
    {
      console.log("Invalid email.");
    }
    else
    {
      console.log({                           //TO DO REMOVE THIS PRIOR TO PRODUCTION IT IS A SECURITY RISK
        "email": email
      });
      const auth = getAuth();
      sendPasswordResetEmail(auth, email).then(() => {
        setCircleProg(false);
          // after email is sent
          handleOpenEmailSentDialog();
      }).catch((error) => {
        // email not sent
        setCircleProg(false);
        seterrorCode(error.code)
        setErrorTitle("Password reset email failed to send");
        handleOpenErrorDialog();
      });
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: "75vh",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'analogous.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Forgot Password
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={handleEmailChange}
              error={!emailRegex.test(email)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Submit
            </Button>
            <Grid container>
              <Grid item>
                <Link href="./signin" variant="body2">
                  {"Remembered your password? Sign In"}
                </Link>
              </Grid>
            </Grid>
          </Box>
          <Hidden xsUp={!circleProg}>
            <CircularProgress color="success" m={10}/>
          </Hidden>
          <Dialog open={openErrorDialog} onClose={handleCloseErrorDialog}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
              <Typography>
                {errorCode}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseErrorDialog}>Close</Button>
            </DialogActions>
          </Dialog>
          <Dialog open={openEmailSentDialog} onClose={handleCloseEmailSentDialog}>
            <DialogTitle>Password Reset</DialogTitle>
            <DialogContent>
              <Typography>
               A password reset link has been sent to <b>{email}</b>. <br/><br/>If you do not see the email in your inbox, please check your spam folder.
              </Typography>
            </DialogContent>
            <DialogActions>
            <Button
                type="button"
                variant="contained"
                onClick={() => window.location.href='/signin'}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}

export default ForgotPassword;